import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './DeleteClientTagDialog.module.css';
import { useDeleteClientTagsMutation } from '../../../generated/graphql';

type DeleteClientTagDialogProps = {
    onClose: () => void,
    tagId: string,
    id: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const DeleteClientTagDialog = (props: DeleteClientTagDialogProps) => {
    const { id, tagId, style, visible, onClose } = props;
    const [deleteClientTag, deleteClientTagResult] = useDeleteClientTagsMutation({
        variables: {
            id: id,
            ids: [tagId]
        }
    });

    const handleOnOkClick = () => {
        deleteClientTag()
            .then(() => onClose())
            .catch(err => onClose());
    };

    return (
        <DialogBase
            title="Delete Client Tag"
            type="OkCancel"
            isLoading={deleteClientTagResult.loading}
            visible={visible}
            onClose={onClose}
            onOkClick={handleOnOkClick}
            className={styles.DeleteClientTagDialog}
            style={style}
            data-testid="DeleteClientTagDialog">
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete this Tag?</p>
        </DialogBase>
    );
};

export default DeleteClientTagDialog;